import { useState } from "react";
import "./Selectbox.css";

const SelectBox = (props) => {
  const [focused, setFocused] = useState(false);

  const isFloating = focused || props.value;

  return (
    <div className={`m-${props.margin} p-${props.padding} ${props.className} w-100`}>
      <label
        className={`labelselect fs-5 ${isFloating ? "floating" : ""} text-${
          props.disabled ? "secondary" : props.bcolor
        }`}
        style={{ "--bg": `${bg(props.bgcolor)} ` }}
        aria-label={props.text}
      >
        <select
          className={`inputselect select-box border-${props.bcolor} text-${props.textcolor}`}
          value={props.value || ""}
          onChange={(e) => props.onChange(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        >
          <option value="">{props.name}</option>
          {props.array.map((option, index) => (
            <option key={option._id || index} value={option._id || option}>
             {option.name || option}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

const bg = (color) => {
  switch (color) {
    case "dark":
      return "#212529";
    case "white":
      return "#ffffff";
    default:
      return "#ffffff";
  }
};

export default SelectBox;
